import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
// import r from 'reactotron-react-js'

import {
  purchaseRequisitionCreatePath,
  purchaseRequisitionDetailPath,
  purchaseRequisitionEditPath
} from '../../'
import { ProcurementContainer, ProcurementBody } from '../styled'
import { PRListCont } from './styled'
import {
  fetchPRList
} from 'ducks/purchaseRequisition'
import {
  getCompanies
} from 'ducks/options'
import {
  columns
} from './AttributeData'
import {
  MainBodyContent,
  CustomButton,
  SearchList,
  TablePagination
} from 'components'

const PurchaseRequisition = (props) => {
  const {
    prList,
    valueForm
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    props.getCompanies()
    window.scrollTo(0, 0)
    props.fetchPRList({ page: 1, size: pageSize })
  }, [])

  return (
    <MainBodyContent headerTitle='Purchase Requisition'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(purchaseRequisitionCreatePath)}
            icon='plus'
            btnColor='gray'
            title='Create' />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList pageSize={pageSize} placeholder='Doc No., Title, Requester' fetchAPI={props.fetchPRList} formSearchName='formSearchPR' filterDate filterStatus />
          <PRListCont>
            <ReactTable
              data={Object.keys(prList).length > 0 ? prList.data : []}
              columns={columns.tPRs(props.companies)}
              defaultPageSize={userPageSize}
              noDataText='No Purchase Requisition found'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className="-striped -highlight"

              PaginationComponent={TablePagination}
              pages={Object.keys(prList).length > 0 ? prList.totalPage : 0}
              currentPage={Object.keys(prList).length > 0 ? prList.page : 0}
              onPageChange={(pageIndex) => {
                props.fetchPRList({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.fetchPRList({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== "") {
                      if ([0, 3, 5].indexOf(Number(rowInfo.original.status)) >= 0) {
                        window.open(purchaseRequisitionEditPath(rowInfo.original.id))
                      } else {
                        window.open(purchaseRequisitionDetailPath(rowInfo.original.id))
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </PRListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  initialValues: {
    formStep: 1
  },
  valueForm: getFormValues('formSearchPR')(state),
  prList: state.pr.prList,
  companies: state.options.companies.data
})

const mapDispatchToProps = {
  fetchPRList,
  getCompanies
}

const contForm = reduxForm({
  form: 'formSearchPR',
  enableReinitialize: true,
})(PurchaseRequisition)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)